import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateStepWiseUserData } from '../../redux/Reducers/userStepsDataDetailReducer';
import { v4 as uuid } from 'uuid';
import { message } from 'antd';
import CustomDropZone from '../../common/CustomDropZone';
import DynamicModal from '../../common/DynamicModal/DynamicModal';
// import TipsForUploadingImages from '../TipsForUploadingImages';
import useAuthContext from '../../hooks/useAuthContext';
import miscApi from '../../apis/misc';
import uploadImage from '../../Images/upload_file.svg';
import './style.scss';
import EmailModal from '../EmailModal';

const { getToSelectSampleImages } = miscApi;
const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
const MAX_UPLOAD_LIMIT = 100;
const StepZero = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [toSelectImages, setToSelectImages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [searchParams] = useSearchParams();
  const [lead, setLead] = useState('')

  
  const {
    user: { userEmail },
    isAuthenticated,
  } = useAuthContext();

  useEffect(()=>{
    const leadId = searchParams.get('leadId');
    if(leadId){
      setLead(leadId);
      localStorage.setItem('leadId', leadId);
    }
  },[window.location]);

  const fetchSampleImages = useCallback(async () => {
    try {
      const res = await getToSelectSampleImages({});
      setToSelectImages(res?.data?.data?.sampleImages || []);
    } catch (err) {
      console.error('Failed to fetch sample images', err);
    }
  }, []);

  useEffect(() => {
    fetchSampleImages();
  }, [fetchSampleImages]);

  

  // useEffect(() => {
  //     setShowModal(true);
  // }, []);

  const handleUploadImage = useCallback(
    (files) => {
      // if (files.length > MAX_UPLOAD_LIMIT) {
      //   message.error(`You cannot upload more than ${MAX_UPLOAD_LIMIT} images`);
      //   return;
      // }

      const modifiedList = files.reduce((acc, file) => {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          message.error('Please upload images only');
          return acc;
        }
        acc.push({
          isFailed: false,
          isSuccess: false,
          isLoading: true,
          file,
          imagePreview: URL.createObjectURL(file),
          _id: uuid(),
          generatedUrl: '',
          generatedKey: '',
          thumbImageUrl: '',
          fileName: file.name,
          fileType: file.type,
        });
        return acc;
      }, []);

      if (modifiedList.length === 0) return;

      dispatch(
        updateStepWiseUserData({
          stepUploadImages: {
            isAllImagesUploaded: false,
            files: modifiedList,
          },
        })
      );

      navigate('/upload-images');
    },
    [dispatch, navigate]
  );

  const handleSampleImageClick = useCallback(
    (file) => {
      dispatch(
        updateStepWiseUserData({
          stepUploadImages: {
            isAllImagesUploaded: false,
            files: [
              {
                isFailed: false,
                isSuccess: true,
                isLoading: false,
                file,
                imagePreview: file?.imagePath?.url,
                _id: uuid(),
                generatedUrl: file?.imagePath?.url,
                generatedKey: file?.imagePath?.key,
                thumbImageUrl: file?.thumbPath?.url,
                fileName: file?.name,
                fileType: '',
              },
            ],
          },
        })
      );

      navigate('/upload-images');
    },
    [dispatch, navigate]
  );

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleAreaClick = () => {
    document.getElementById('file').click();
  };

  const onDropItems = useCallback(
    (files) => {
      // if (files.length > MAX_UPLOAD_LIMIT) {
      //   message.error(`You cannot upload more than ${MAX_UPLOAD_LIMIT} images`);
      //   setIsDragging(false);
      //   return;
      // }
      handleUploadImage(files);
    },
    [handleUploadImage]
  );

  const renderImageUploadingSection = useCallback(
    () => (
      <div className="left_column_wrapper">
        <div className="left_column">
          <div className="top_section">
            <div
              className="drop_zone_custom_container"
              onClick={handleAreaClick}
            >
              <img
                src={uploadImage}
                alt="upload_images"
                className="upload_image_icon"
              />
              <p className="line_1">
                Drop your image here, or{' '}
                <label className="browse_btn">browse</label>
              </p>
              <p className="line_1_mobile">
                <label className="browse_btn">Upload</label> your images
              </p>
              <p className="line_2">File size not more than 15MB</p>
            </div>
          </div>

          <input
            type="file"
            accept="image/png,image/jpg,image/jpeg,image/webp"
            id="file"
            onChange={(e) => handleUploadImage([...e.target.files])}
            onClick={(e) => {
              e.target.value = null;
            }}
            className="upload_more_images_btn_input"
            multiple
          />

          {/* <div className="bottom_section">
            <div className="support_line_1">
              No image? Try one of demo images:
            </div>
            <div className="sample_images_wrapper">
              {toSelectImages.map((item, index) => (
                <div className="sample_image_wrapper" key={index}>
                  <img
                    src={item?.thumbPath?.url}
                    alt={item?.name}
                    className="sample_image_main"
                    onClick={() => handleSampleImageClick(item)}
                  />
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    ),
    [toSelectImages, handleUploadImage, handleSampleImageClick]
  );

  // const renderRightVideoSection = useCallback(
  //   () => (
  //     <div className="right_column_wrapper">
  //       <div className="right_column"></div>
  //     </div>
  //   ),
  //   []
  // );

  const renderDragAndDropSection = useCallback(
    () =>
      isDragging && (
        <CustomDropZone
          dropZoneClass={'uploaded_images_row'}
          onDropItems={onDropItems}
          isShowTextOnDrag={true}
          acceptingFormates={{
            'image/jpg': [],
            'image/png': [],
            'image/jpeg': [],
            'image/webp': [],
          }}
          handleDragLeave={handleDragLeave}
        />
      ),
    [isDragging, onDropItems, handleDragLeave]
  );

  

  return (
    <div className="step_zero_main_wrapper" onDragEnter={handleDragEnter}>
      <div className="space-col"></div>
      {renderImageUploadingSection()}
      <div className="space-col"></div>
      {/* {renderRightVideoSection()} */}
      {/* <div className="space-col"></div> */}
      {renderDragAndDropSection()}
    </div>
  );
};

export default StepZero;
